/**
 * Parses a naive datetime string (e.g. "2024-06-28 14:00" or "2024-06-28 14:00:00")
 * as a Stockholm local time (Europe/Stockholm) and returns the corresponding Date (UTC).
 *
 * This is needed because all events on the platform take place in Stockholm, so times
 * entered in the form are always in the Europe/Stockholm timezone regardless of where
 * the user's browser is located.
 */
export function parseStockholmTime(dateString: string): Date {
  const normalized = dateString.replace(' ', 'T');

  // Parse the string as if it were UTC (append 'Z')
  const asUTC = new Date(normalized + 'Z');

  // Find Stockholm's UTC offset at this moment by comparing what UTC and Stockholm
  // display for the same instant. Both use sv-SE locale which produces parseable
  // "YYYY-MM-DD HH:MM:SS" strings.
  const utcStr = asUTC.toLocaleString('sv-SE', { timeZone: 'UTC' });
  const stockholmStr = asUTC.toLocaleString('sv-SE', { timeZone: 'Europe/Stockholm' });

  const utcMs = new Date(utcStr.replace(' ', 'T') + 'Z').getTime();
  const stockholmMs = new Date(stockholmStr.replace(' ', 'T') + 'Z').getTime();

  // offsetMs is positive when Stockholm is ahead of UTC (e.g. +2h in summer)
  const offsetMs = stockholmMs - utcMs;

  // Subtract the offset so the result, when displayed in Stockholm, shows the
  // original input time.
  return new Date(asUTC.getTime() - offsetMs);
}
